const PROJECTS = [
  {
    name: "middlepathtemple",
    moreUrls: [
      "/assets/projects/middlepathtemple/1.jpg",
      "/assets/projects/middlepathtemple/2.jpg",
      "/assets/projects/middlepathtemple/3.jpg",
    ],
    mainUrl: "/assets/projects/middlepathtemple/main.jpg",
    mainUrlSmall: "/assets/projects/middlepathtemple/main-min.jpg",
    projectName: "Middle Path Buddhist Temple of Calgary",
    location: "Rocky View County, Alberta",
    size: "4200 sqft",
    description:
      "Located in Rocky View County, this project is the first Buddhist Temple of its kind in Alberta. It contains special landscape and exterior features, including a sizable solar farm to supply electricity, as well as a library tower.",
  },
  {
    name: "bridgeland",
    moreUrls: ["/assets/projects/bridgeland/1.jpg"],
    mainUrl: "/assets/projects/bridgeland/main.jpg",
    mainUrlSmall: "/assets/projects/bridgeland/main-min.jpg",
    projectName: "The Riverside Multi-Residential",
    location: "Calgary, Alberta",
    size: "43200 sqft",
    description:
      "Located within an inner city neighborhood of NE Calgary, this project contributes to and compliments the atmosphere of the community with enhanced landscaping and roof top amenities, to not only enhance the surrounding area, but to provide the sought-after density and gentrification.",
  },
  {
    name: "apartment15",
    moreUrls: ["/assets/projects/apartment15/1.jpg"],
    mainUrl: "/assets/projects/apartment15/main.jpg",
    mainUrlSmall: "/assets/projects/apartment15/main-min.jpg",
    projectName: "15th Ave Apartment",
    location: "Calgary, Alberta",
    size: "40000 sqft",
    description: "",
  },
  {
    name: "tang",
    moreUrls: [],
    mainUrl: "/assets/projects/tang/main.jpg",
    mainUrlSmall: "/assets/projects/tang/main-min.jpg",
    projectName: "Wood-Frame Apartments",
    location: "Calgary, Alberta",
    size: "8 Units",
    description: "",
  },
  {
    name: "starr",
    moreUrls: [],
    mainUrl: "/assets/projects/starr/main.jpg",
    mainUrlSmall: "/assets/projects/starr/main-min.jpg",
    projectName: "Modular Apartments",
    location: "Calgary, Alberta",
    size: "8 Units",
    description: "",
  },
  {
    name: "brentwood",
    moreUrls: [],
    mainUrl: "/assets/projects/brentwood/main.jpg",
    mainUrlSmall: "/assets/projects/brentwood/main-min.jpg",
    projectName: "Brentwood Professional Offices",
    location: "Calgary, Alberta",
    size: "17800 sqft",
    description: "",
  },
  {
    name: "turnervalley",
    moreUrls: ["/assets/projects/turnervalley/1.jpg"],
    mainUrl: "/assets/projects/turnervalley/main.jpg",
    mainUrlSmall: "/assets/projects/turnervalley/main-min.jpg",
    projectName: "Centre 78",
    location: "Turner Valley, Alberta",
    size: "40000 sqft",
    description:
      "Turner Valley Community Hall is a Joint-Use Community Center, designed to reflect the town image and architecture associated with the ideals of the western oil & gas boom. Major building materials used include heavy timber and wood construction, as well as local materials including field stones and local timbers. The site design also featured a torch water feature and local wood & stone walkways and benches.",
  },
  {
    name: "barberry",
    moreUrls: [],
    mainUrl: "/assets/projects/barberry/main.jpg",
    mainUrlSmall: "/assets/projects/barberry/main-min.jpg",
    projectName: "Barberry Walk Tower",
    location: "Calgary, Alberta",
    size: "90000 sqft",
    description:
      "This was a renovation project that involved replacing all exterior components including walls, windows, doors. It also included a redesign of the main lobby, entrance, and canopy. The renovation revitalized the old, grey exterior, and improved energy efficiency.\n Sharon Wang designed the building with Hasegawa Group.",
  },
  {
    name: "shellcarmoncreek",
    moreUrls: [
      "/assets/projects/shellcarmoncreek/1.jpg",
      "/assets/projects/shellcarmoncreek/2.jpg",
    ],
    mainUrl: "/assets/projects/shellcarmoncreek/main.jpg",
    mainUrlSmall: "/assets/projects/shellcarmoncreek/main-min.jpg",
    projectName: "Shell Pre-Engineered ACM Building",
    location: "Carmon Creek, Northern Alberta",
    size: "58000 sqft",
    description:
      "The Shell Peace River Complex, located about 55 kilometers northeast of Peace River, is the second largest of Shell’s oil assets in Alberta. The Carmon Creek Project is a phased commercial development project to expand the current thermal production in the Peace River Lease. The ACM (Administration, Control Room and Maintenance) building is located at the centre of the Carmon Creek project. The building will house operations group, administration and supporting staff including operation supervisors, training personnel, maintenance staff and maintenance contractors.",
  },
  {
    name: "chevron",
    moreUrls: [],
    mainUrl: "/assets/projects/chevron/main.jpg",
    mainUrlSmall: "/assets/projects/chevron/main-min.jpg",
    projectName: "Chevron LNG Administration Building",
    location: "Kitimat, British Columbia",
    size: "30000 sqft",
    description:
      "The Great Thunderbird, a First Nations symbol, is integrated into the building design. The strong geometry is clearly recognizable.\n The exterior of upper floor is articulated as glazed pavilion, presenting luminous, transparent facades to the access road and back of site. This allows day-lighting to be maximized while allowing visual interconnection between interior and exterior.The facades are to be constructed using ventilated double-skin curtain wall systems in a composition of transparent and translucent glass.\n Solar panels are to be introduced to this building for roofing and south facing facades to perform energy efficiency of building. By using solar power will also greatly reduce the impact on the environment.",
  },
  {
    name: "chinesebuddhisttemple",
    moreUrls: ["/assets/projects/chinesebuddhisttemple/1.jpg"],
    mainUrl: "/assets/projects/chinesebuddhisttemple/main.jpg",
    mainUrlSmall: "/assets/projects/chinesebuddhisttemple/main-min.jpg",
    projectName: "Chinese Buddhist Temple Annex",
    location: "Calgary, Alberta",
    size: "6000 sqft",
    description:
      "This project is an addition of the existing Calgary Chinese Buddhist Temple. The intent of the new addition is to create an identical image of the existing portion. The constraint of the site and discontinuation of the existing materials were challenges faced throughout this project.",
  },
  {
    name: "macleod",
    moreUrls: [],
    mainUrl: "/assets/projects/macleod/main.jpg",
    mainUrlSmall: "/assets/projects/macleod/main-min.jpg",
    projectName: "Macleod Trail Mixed Use Building",
    location: "Calgary, Alberta",
    size: "107500 sqft",
    description: "",
  },
  {
    name: "southbow",
    moreUrls: [],
    mainUrl: "/assets/projects/southbow/main.jpg",
    mainUrlSmall: "/assets/projects/southbow/main-min.jpg",
    projectName: "South Bow Mixed Use Building",
    location: "Calgary, Alberta",
    size: "35000 sqft",
    description:
      "This development provides both commercial use at ground level, as well as residential space above. The development is meticulously designed in its form, height, and scale. The streetscapes/building frontages of the neighbouring streets have been carefully considered.",
  },
  {
    name: "zhao",
    moreUrls: [
      "/assets/projects/zhao/1.jpg",
      "/assets/projects/zhao/2.jpg",
      "/assets/projects/zhao/3.jpg",
    ],
    mainUrl: "/assets/projects/zhao/main.jpg",
    mainUrlSmall: "/assets/projects/zhao/main-min.jpg",
    projectName: "Zhao Residence Interior",
    location: "China",
    size: "3600 sqft",
    description: "",
  },
  {
    name: "helin",
    moreUrls: [
      "/assets/projects/helin/1.jpg",
      "/assets/projects/helin/2.jpg",
      "/assets/projects/helin/3.jpg",
    ],
    mainUrl: "/assets/projects/helin/main.jpg",
    mainUrlSmall: "/assets/projects/helin/main-min.jpg",
    projectName: "HeLin Residence Interior",
    location: "China",
    size: "3500 sqft",
    description: "",
  },
  {
    name: "hou",
    moreUrls: [
      "/assets/projects/hou/1.jpg",
      "/assets/projects/hou/2.jpg",
      "/assets/projects/hou/3.jpg",
    ],
    mainUrl: "/assets/projects/hou/main.jpg",
    mainUrlSmall: "/assets/projects/hou/main-min.jpg",
    projectName: "Hou Residence Interior",
    location: "China",
    size: "4000 sqft",
    description: "",
  },
];

export default PROJECTS;



// WEBPACK FOOTER //
// ./src/projects.js